import { globalVariables } from "helper/globalVariables";
import Dropdown from "shared/Components/dropdown";
import { rolesForAdmin, rolesForOther } from "./constants";
import { ROLE } from "helper/utility";
import { useContext } from "react";
import { OrignalRoleContext } from "context/RoleContext";
import { useSelector } from 'react-redux';

export const SwitchRole = ({
  onChangeRole,
  defaultRole,
  isJudge = false,
  rolesData = rolesForOther,
}) => {
  const originalRole = useContext(OrignalRoleContext);
  const onSwitchRole = (role) => {
    onChangeRole(role);
  };
  const memberDetails = useSelector(
    (state) => state?.auth?.memberReducer?.memberDetails
  );

  return (
    <>
      <div className="flex justify-center md:justify-start lg:justify-start">
        <Dropdown
          isShadow={true}
          dynamicHeight
          dropdownOptions={ rolesData }
          placeholder={globalVariables.userRolePlaceHolder}
          defaultOption={defaultRole}
          onChange={onSwitchRole}
          label={globalVariables.userRolePlaceHolder}
          width={
            "w-[358px] lg:w-[384px] max-[400px]:w-[340px] max-[280px]:w-[250px]"
          }
        />
      </div>
    </>
  );
};
